import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=6a20cf54&scoped=true"
import script from "./ModuleHeader.vue?vue&type=script&lang=js"
export * from "./ModuleHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleHeader.vue?vue&type=style&index=0&id=6a20cf54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20cf54",
  null
  
)

export default component.exports